import { maxSizeMB } from "./../config/constants.js";
/**
 * バリデーションメッセージのオブジェクト
 * @constant {object} enMessages
 */
const enMessages = {
    REQUIRED: "Please enter a value.",
    REQUIRED_SELECT: "Please make a selection.",
    ANY_REQUIRED: "Please fill in at least one field.",
    TEL: "Invalid phone number format.",
    MAIL: "Invalid email address format.",
    NUM: "Please enter only numeric characters.",
    ALPHABET: "Please enter only alphabetic characters.",
    ALPHA_NUM: "Please enter only alphanumeric characters.",
    ZIP: "Invalid postal code format.",
    ADDR: "The postal code does not exist.",
    KANA: "Please enter in hiragana or katakana.",
    HIRAGANA: "Please enter only hiragana characters.",
    KATAKANA: "Please enter only katakana characters.",
    FILE: "Unsupported file format.",
    UPLOAD: `The maximum file size is ${maxSizeMB}MB.`,
    CONFIRM: "The input does not match.",
    NO_INPUT: "There are items with errors.",
};
export default enMessages;
//# sourceMappingURL=en.js.map